import React from "react";
import "./Footer.css";
import wp from "../../assets/whatsapp-logo.jpg"

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
    <div className="Footer-container" id="about">
    <section className="footer">
        <div className="box-container">
          <div className="box" data-aos="fade-right">
            <h3>FitClub</h3>
            <p>Your trusted fitness partner. Join us to shape your ideal body and live your best life.</p>
            <a href={`https://wa.me/+923356620397`}><img alt="whatsapp" src={wp} height="60" width="180" className="btn-whatsapp"/></a>
          </div>
        <div className="box" data-aos="fade-up">
            <h3>Contact Us</h3>
            <p><a href="tel:+923356620397">+92 3356620397</a></p>
            <p><a href="mailto:awais6javaid@gmail.com">awais6javaid@gmail.com</a></p>
            <p>Lahore, Pakistan</p>
            <div className="social-links">
              <a href="Facebook" aria-label="Facebook"><i className="fab fa-facebook-f"></i> Facebook</a>
              <a href="Instagram" aria-label="Instagram"><i className="fab fa-instagram"></i> Instagram</a>
              <a href={`https://wa.me/+923356620397`} aria-label="Whatsapp"><i className="fab fa-whatsapp"></i> WhatsApp</a>
              <a href="https://www.google.com/maps/" aria-label="Location"><i className="fab fa-google"></i> Location</a>
            </div>
        </div>
        <div className="box" data-aos="fade-left">
            <h3>Quick Links</h3>
            <a href="#programs">Programs</a>
            <a href="#plans">Plans</a>
            <a href="#testimonials">Testimonials</a>
            <a href="#contact">Contact</a>
            <a href="#about">About Us</a>
        </div> 
      </div>
    </section>
    <div className="credits" data-aos="fade-up">
        <p>© {currentYear} Awais Sufi. All Rights Reserved.</p>
      </div>
    </div>
    </>
  );
};

export default Footer;
